/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Report-translation admin list, editor, and copy modal.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminListModule} from '../common/directives/admin-list.module';
import {ReportTranslationCopyModalComponent} from './report-translation-copy-modal.component';
import {ReportTranslationEditPageComponent} from './report-translation-edit-page.component';
import {ReportTranslationListPageComponent} from './report-translation-list-page.component';
import {ReportTranslationRoutePageComponent} from './report-translation-route-page.component';

const REPORT_TRANSLATION = [
  ReportTranslationCopyModalComponent,
  ReportTranslationEditPageComponent,
  ReportTranslationListPageComponent,
  ReportTranslationRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule
  ],
  declarations: REPORT_TRANSLATION,
  exports: REPORT_TRANSLATION
})
export class ReportTranslationModule {
}
